const reducer = (state, action) => ({
  ...state,
  loading: false,
  addresses: [],
  error: action.error,
});

export default reducer;
